import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../state'

/** Binds the editing-variables feature to the canonical table. */
@ngCore.Component({
  imports: [ds.table.Component],
  selector: 'atn-variables-table',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.admin.editingVariables.Feature} */
  public readonly editingVariablesFeature = ngCore.inject(
    state.admin.editingVariables.Feature,
  )
}
